<template>
  <RoughAssessment
    v-if="!level"
    v-bind:rough="skill.rough"
    v-bind:locale="locale"
    v-model="result.rough"
  />
  <router-view
    v-else
    v-bind:level="level"
    v-bind:questions="skill[level]"
    v-bind:type="type"
    v-bind:locale="locale"
    v-model="result[level]"
  ></router-view>
</template>

<script>
import RoughAssessment from "./components/RoughAssessment.vue";
export default {
  name: "Skill",
  props: {
    value: Object,
    skill: Object,
    level: String,
    locale: String,
    type: String
  },
  components: {
    RoughAssessment
  },
  computed: {
    result: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate;
    }
  }
};
</script>

<style></style>
